import React, {useEffect, useMemo, useState} from "react"

import Confetti from "react-confetti"

import {useIsResponsive} from "../../hooks/useIsResponsive"
import colors from "../../styles/_default.colors.module.scss"
import sizes from "../../styles/_default.sizes.module.scss"
import {cssLengthToPx, readViewport} from "../../utils/sizes"

const DOMISERVE_COLORS = [colors.darkBlue800, colors.yellow400, colors.lightBlue400, colors.pink700]
const NUMBER_OF_CONFETTIS = 200
const TWEEN_DURATION = 600
const GRAVITY = 0.12
const Z_INDEX = 1001

/**
 * Fais apparaitre des confettis en plein écran (librairie react-confetti)
 * La zone d’émission est alignée sous le header.
 */
const Confettis = props => {
    const isResponsive = useIsResponsive()

    const [{w, h}, setViewport] = useState(() => readViewport())

    const y = useMemo(() => {
        const headerHeightToken = isResponsive ? sizes.headerMobileTotalHeight : sizes.headerTotalHeight

        return cssLengthToPx(headerHeightToken)
    }, [isResponsive])

    // Met à jour la largeur et la hauteur lors d'un redimensionnement de la page
    useEffect(() => {
        const update = () => setViewport(readViewport())
        update()
        window.addEventListener("resize", update)
        window.addEventListener("scroll", update, {passive: true})

        const vv = window.visualViewport
        vv?.addEventListener("resize", update)
        vv?.addEventListener("scroll", update)

        return () => {
            window.removeEventListener("resize", update)
            window.removeEventListener("scroll", update)
            vv?.removeEventListener("resize", update)
            vv?.removeEventListener("scroll", update)
        }
    }, [])

    return (
        <Confetti
            colors={DOMISERVE_COLORS}
            confettiSource={{
                x: 0,
                y,
                w,
                h: 0,
            }}
            gravity={GRAVITY}
            height={h}
            numberOfPieces={NUMBER_OF_CONFETTIS}
            recycle={false}
            style={{
                position: "fixed",
                zIndex: Z_INDEX,
            }}
            tweenDuration={TWEEN_DURATION}
            width={w}
            {...props}
        />
    )
}

export default Confettis
